import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import ActionButton from "../general/ActionButton";
import { LoadingLine } from "../general/LoadingLine";
import { Switch } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getDefaultInsurersList,
  getDefaultInsurersListSelector,
} from "../store/brokerage";
import {
  toggleAddInsurerModal,
  addInsurer,
  updateInsurer,
  getAddInsurerStatus,
  getSelectedInsurerDetails,
  getInsurerDetails,
  getInsurerOptions,
  getInsurerOptionsList,
  getInsBrokerageList,
  getInsurerBrokerList,
} from "../store/insurers";
import { getVerticalList, loadverticals } from "../store/verticals";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { Redirect } from "react-router-dom";
import Select from "react-dropdown-select";
import { useNavigate, useSearchParams } from "react-router-dom";

const InsurerAdminBrokerageList = (props) => {
  return (
    <InsurerAdminBrokerageListDashboardPane
      insurerCode={props.insurerCode}
    ></InsurerAdminBrokerageListDashboardPane>
  );
};

const InsurerAdminBrokerageListDashboardPane = (props) => {
  const [insurer, setInsurer] = useState(null);
  const [isAllChecked, setisAllChecked] = useState(false);

  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  let [isLoading, setisLoading] = useState(false);

  const queryCode = searchParams.get("c");
  let history = useNavigate();
  useEffect(() => {
    dispatch(getDefaultInsurersList());
    dispatch(getInsBrokerageList({ code: queryCode }));
  }, []);
  let insContacts = useSelector(getDefaultInsurersListSelector);
  let insBrokerageList = useSelector(getInsurerBrokerList);

  useEffect(() => {
    if (isLoading) {
      setisLoading(false);
    }
  }, [insBrokerageList]);
  // On operation selected
  const onChangeHandle = async (value) => {
    if (value[0]?.code) {
      setInsurer(null);
      await dispatch(getInsurerDetails(value[0].code));
      await dispatch(getInsBrokerageList({ code: value[0].code }));
      history(
        "/quoteyadmin/brokeragelist?c=" + encodeURIComponent(value[0].code)
      );
    }
  };

  if (insContacts && props.insurerCode && insurer == null) {
    for (let ic of insContacts) {
      if (ic.code == props.insurerCode) {
        setInsurer(ic);
      }
    }
    //if (insurer == null) setInsurer(insContacts[0]);
  } else if (insContacts && insContacts[0]?.code && !props.insurerCode) {
    //setInsurer(null);
    history(
      "/quoteyadmin/insurerBrokerageList?c=" +
        encodeURIComponent(insContacts[0]?.code)
    );
  }

  if (queryCode && insurer && insurer.code && insurer.code != queryCode) {
    let insContact = insContacts.find((x) => x.code == queryCode);
    setInsurer(insContact);
  }

  const handleToggleAllInsurers = async (switchValue, column = "isactive") => {
    setisLoading(true);
    var dataArr = [];
    for (let insurer_ of insBrokerageList) {
      if (column == "isactiveforusers") {
        if (insurer_.isactiveforusers != switchValue) {
          dataArr.push({ ...insurer_, isactiveforusers: switchValue });
        }
      } else {
        if (insurer_.isactive != switchValue) {
          dataArr.push({ ...insurer_, isactive: switchValue });
        }
      }
    }
    //setisLoading(false)
    dispatch(getInsBrokerageList({ code: queryCode, switchArr: dataArr }));
  };

  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        {/* <h5 className="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>You can customize the e-mail contacts and names that your team sees for insurers when sending to market.</h5> */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "5%",
            paddingRight: "5%",
          }}
        >
          {}

          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div style={{ width: "100%" }}>
              <Select
                placeholder={insurer ? insurer.name : "Search for an insurer"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onChangeHandle(values)}
                values={[]}
                options={insContacts}
                style={{
                  width: "100%",
                  height: "6vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <br />
        </div>
        <div className="d-flex align-items-center">
          <h5
            className="px-2"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Select which insurers are available for the brokerages to use.
          </h5>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "40px",
            }}
          >
            <button
              onClick={() => {
                const array_ = [Object.keys(insBrokerageList[0])].concat(
                  insBrokerageList
                );
                const csvData = array_
                  .map((it) => {
                    return Object.values(it).toString();
                  })
                  .join("\n");
                const url = window.URL.createObjectURL(new Blob([csvData]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  `${queryCode}_brokerageAccess.csv`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();
              }}
            >
              CSV
            </button>
            {isLoading && (
              <LoadingLine
                type={"spokes"}
                color={theme.COLORS.primary_navyblue}
              ></LoadingLine>
            )}
            <Tooltip title="isactive">
              <Switch
                color="primary"
                // checked={isAllChecked}
                onChange={(e) => {
                  handleToggleAllInsurers(e.target.checked);
                }}
              />
            </Tooltip>
            <span style={{ color: "#212529", fontWeight: "bold" }}>
              Make it all as Default
            </span>
            <Tooltip title="isactiveforusers">
              <Switch
                color="primary"
                // checked={isAllChecked}
                onChange={(e) => {
                  handleToggleAllInsurers(e.target.checked, "isactiveforusers");
                }}
              />
            </Tooltip>
          </div>
        </div>
        <div></div>
        <InsurerVerticalItems insurer={insurer} setInsurer={setInsurer} />
      </div>
    </div>
  );
};

const InsurerVerticalItems = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadverticals());
  }, []);
  let verticals = useSelector(getVerticalList);
  let insBrokerageList = useSelector(getInsurerBrokerList);
  const checkIfVerticalHasBrokerageList = (item) => {
    if (props.insurer && props.insurer.verticalids) {
      return props.insurer.verticalids.includes(item.id);
    } else return false;
  };
  return (
    <div
      className="m-4"
      style={{
        fontFamily: "GibsonRegular",
        fontSize: "0.8vw",
        justifyContent: "center",
      }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">Brokerage</th>
            <th scope="col">isactive</th>
            <th scope="col">isactiveforusers</th>
          </tr>
        </thead>
        <tbody>
          {insBrokerageList ? (
            insBrokerageList.map((item, index) => {
              return (
                <Fragment key={index}>
                  <tr scope="row" className="thead-light">
                    <th scope="row" value={item.brokerage_code}>
                      {item.name}
                    </th>
                    <th scope="row">
                      <Switch
                        checked={item.isactive}
                        color="primary"
                        onChange={() => {
                          let verts = [];
                          let data = { ...item, isactive: !item.isactive };
                          dispatch(
                            getInsBrokerageList({
                              code: item.insurer_code,
                              switch: data,
                            })
                          );
                        }}
                      />
                    </th>
                    <th scope="row">
                      <Switch
                        checked={item.isactiveforusers}
                        color="primary"
                        onChange={() => {
                          let data = {
                            ...item,
                            isactiveforusers: !item.isactiveforusers,
                          };
                          dispatch(
                            getInsBrokerageList({
                              code: item.insurer_code,
                              switch: data,
                            })
                          );
                        }}
                      />
                    </th>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InsurerAdminBrokerageList;
